export default "__VITE_PUBLIC_ASSET__263c8fa3__"